<header  [ngClass]="{'border-dashboard': isDashboard}">
  <div class="header_wrapper">
    <div class="logo">
      <span>Bacon Arcade</span>
    </div>

    <nav class="nav-links">
      <a routerLink="/dashboard" routerLinkActive="active">Games</a>
      <a routerLink="/shop" routerLinkActive="active">Shop</a>
      <a routerLink="/support" routerLinkActive="active">Support</a>
    </nav>

    <div class="user-info">
      <div class="balance">
        <img src="../../../../assets/images/coin.png" alt="coins">
        <span>{{ user()?.balance }}</span>
      </div>
      <div class="profile-wrapper">
        <div class="avatar" (click)="toggleDropdown()">
          <img [src]="'assets/images/avatars/'+ user()?.avatar" alt="User Avatar">
        </div>
        <div class="dropdown-menu" [class.show]="isDropdownOpen" #dropdown>
          <div class="menu-item" (click)="goToProfile()">
            <i class="pi pi-user"></i> Profile
          </div>
          <div class="menu-item" (click)="logout()">
            <i class="pi pi-sign-out"></i> Log out
          </div>
        </div>
      </div>
    </div>
  </div>
</header>
